import { type UpdatedAccess } from './types';

export const updateUserPermissionsModel = (
  updatedAccess: Record<string, Array<string>> = {}
): UpdatedAccess => ({
  entity: Object.keys(updatedAccess) || [],
  entityJurisdiction: Object.values(updatedAccess).flat(1) || [],
});
